<template>
  <div class="home">
    <div class="box">
      <h1 class="title">欢迎登录CRM系统</h1>
      <h4 class="subtitle">COPYRIGHT © {{thisYear}} Huanchu</h4>
      <img width="306" src="../assets/images/home.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({name: 'login'});
    }
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    }
  },
}
</script>
<style lang="scss" scoped>
.home {
  height: calc(100vh - 3.5rem - 2.2rem );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .box {
    text-align: center;
  }
  .title {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .subtitle {
    color: #6E6B7B;
    font-size: 14px;
    margin-bottom: 64px;
  }
}
</style>
